
export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
    unavailable: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedDays: this.value,
      days: [
        'Ma',
        'Di',
        'Wo',
        'Do',
        'Vr',
        'Za',
        'Zo',
      ],
    };
  },
  watch: {
    value() {
      this.selectedDays = this.value;
    },
    selectedDays() {
      this.$emit('input', this.selectedDays);
    },
  },
};
